export interface ICardDef {
    id: string;
    icon: string;
    title: string;
    subtitle: string;
    bgColor: string;
    hoverColor: string;
    hoverText: string;
    action: () => void;
}